import 'pixi-layers'

import { buildLayout } from 'core/Factory'
import { addStats } from 'pixi-stats'
import { signal } from 'services/SignalsService'
import { view } from 'settings/base'
import { debug } from 'settings/custom/build'
import { layout } from 'settings/custom/layout'
import { mlayout } from 'settings/custom/mlayout'
import { Device } from 'utils/Device'

export default class Application extends PIXI.Application {
  constructor(color, density) {
    super({
      autoDensity: true,
      antialias: false,
      backgroundColor: color,
      resolution: density,
    })

    this.density = density

    this.build = []
    this._layer = {}
    this.displayGroups = {}

    this.stage = new PIXI.display.Stage()

    this.container = new PIXI.Container()

    this.stage.addChild(this.container)

    this.createDisplayGroups()

    this.makeInit()

    if(debug){
      const stats = addStats(document,   this)
      this.ticker.add(stats.update, stats, PIXI.UPDATE_PRIORITY.UTILITY)
      this.fps()
    }

    signal.on('RESIZE',  () => {
      this.resizer()
    })
  }

  createDisplayGroups() {
    const sort = true

    this.displayGroups.MAIN     = new PIXI.display.Group(1, sort)
    this.displayGroups.SPLASH   = new PIXI.display.Group(2, sort)
    this.displayGroups.INIT     = new PIXI.display.Group(3, sort)

    this._layer.MAIN = new PIXI.display.Layer(this.displayGroups.MAIN)
    this._layer.SPLASH = new PIXI.display.Layer(this.displayGroups.SPLASH)
    this._layer.INIT = new PIXI.display.Layer(this.displayGroups.INIT)

    this.stage.addChild(this._layer.MAIN )
    this.stage.addChild(this._layer.SPLASH)
    this.stage.addChild(this._layer.INIT)
  }

  fps(){
    const dom = document.getElementById('stats')
    dom.style.display =  'none'

    signal.on('TOGGLE:fps', (value) => {
      dom.style.display = !value ? 'none' : 'block'

    })
  }

  makeInit() {

    this.resizer()

    this.prepare('INIT')
    this.update()
    document.getElementById('loading').style.display = 'none'
  }

  makeSplash(callback) {
    this.prepare('SPLASH')
    this.update()
    callback()

  }

  makeMain(callback) {

    this.prepare('MAIN')
    this.update()
    callback()

  }

  prepare(GROUP) {
    const condition = GROUP !== 'MAIN' ? GROUP : undefined

    const layers = Device.isDesktop()
      ? layout.filter((layer) => layer.properties.parentGroup === condition)
      : mlayout.filter((layer) => layer.properties.parentGroup === condition)
    this.build = buildLayout(layers)
    this.build.forEach((container) => container.parentGroup = this.displayGroups[GROUP])
  }

  update() {
    this.container.addChild(...this.build)
  }

  resizer() {
    const screen = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
    const orientation = screen.width > screen.height ? 'land' : 'port'
    const stage = Device.isDesktop() ? view.desktop[orientation] : view.mobile[orientation]
    const scale = Math.min(screen.width / stage.width, screen.height / stage.height)

    this.renderer.resize(screen.width, screen.height)
    this.container.scale.set(scale)
    this.container.x = (screen.width - stage.width * scale) / 2
    this.container.y = (screen.height - stage.height * scale) / 2
  }

}
